<template>
  <a-layout class="container">
    <!-- 左侧区域 -->
    <hina-base-slider
      :currentMenuKey="curMenuKey"
      :currentOpenKey="curOpenKey"
    />
    <!-- 主体区域 -->
    <a-layout>
      <!-- 头部 -->
      <hina-user-info :user="objUserInfo" />

      <a-layout-content>
        <!-- 位置 -->
        <hina-bread-crumb :link="arrBreadLink" />

        <!-- 主体 -->
        <a-spin :spinning="spinning">
          <div class="wrapper">
            <div class="wrap">
              <div class="hd">资金统计</div>
              <div class="bd">
                <a-row class="amount-list">
                  <a-col :span="8" class="amount-item">
                    <div class="counter-box">
                      <div class="txt">{{ totalRecharge }}</div>
                      <div class="lab">累计充值金额</div>
                    </div>
                  </a-col>
                  <a-col :span="8" class="amount-item">
                    <div class="counter-box">
                      <div class="txt">{{ allocatedBalance }}</div>
                      <div class="lab">已分配余额</div>
                    </div>
                  </a-col>
                  <a-col :span="8" class="amount-item">
                    <div class="counter-box">
                      <div class="txt">{{ unallocatedBalance }}</div>
                      <div class="lab">账户余额</div>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </div>

            <div class="wrap">
              <div class="hd">在线充值</div>
              <div class="bd">
                <a-row class="frm-line">
                  <a-col :span="4" class="lab required">选择支付方式</a-col>
                  <a-col :span="20">
                    <div class="pay" v-if="arrPayment.length > 0">
                      <div
                        class="pay-item"
                        :class="{
                          'pay-item_hov': index == recharge.curPayment,
                        }"
                        :data-index="index"
                        @click="handlerChangePayment"
                        v-for="(item, index) in arrPayment"
                        :key="index"
                      >
                        <img v-if="index < 2" :src="item.icon" class="ico" />
                        <div v-if="index < 2" class="inf">
                          {{ item.paymentName }}
                        </div>
                        <img v-if="index == 2" :src="item.icon" class="pic" />
                      </div>
                    </div>
                  </a-col>
                </a-row>
                <a-row class="frm-line">
                  <a-col :span="4" class="lab required">充值金额</a-col>
                  <a-col :span="6" class="txt-money">
                    <a-input prefix="￥" v-model="recharge.rechargeAmount" />
                  </a-col>
                </a-row>
                <a-row class="frm-line">
                  <a-col :offset="4" :span="10" class="btn">
                    <a-button type="primary" @click="handleRecharge"
                      >立即充值</a-button
                    >
                  </a-col>
                </a-row>

                <a-modal
                  v-model="qrCodeVisible"
                  :bodyStyle="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center',
                  }"
                  title="扫一扫"
                  :centered="true"
                  :footer="null"
                >
                  <vue-qr
                    :logoSrc="qrCode.logoSrc"
                    :text="qrCode.text"
                    :size="450"
                    :correctLevel="3"
                  ></vue-qr>
                </a-modal>
              </div>
            </div>

            <div class="wrap">
              <div class="hd">
                <div class="filter">
                  <div class="title">交易流水</div>
                  <div class="query">
                    <div class="query-item">
                      <a-dropdown-button>
                        {{ strTransType }}
                        <a-menu
                          slot="overlay"
                          @click="handleMenuClick"
                          style="line-height: 48px"
                        >
                          <a-menu-item key="1">充值</a-menu-item>
                          <a-menu-item key="2">退款</a-menu-item>
                        </a-menu>
                        <a-icon slot="icon" type="user" />
                      </a-dropdown-button>
                    </div>
                    <div class="query-item">
                      <a-range-picker
                        :show-time="{ format: 'HH:mm' }"
                        format="YYYY-MM-DD HH:mm"
                        :placeholder="['开始时间', '结束时间']"
                        :locale="locale"
                        @change="onDateTimeChange"
                        @ok="onDateTimeOk"
                      >
                        <a-icon slot="suffixIcon" type="calendar" />
                      </a-range-picker>
                    </div>
                    <div class="query-item">
                      <a-button type="primary" @click="getTransactions"
                        >查询
                      </a-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="trans-table">
                <a-table
                  :columns="arrTabCol"
                  :data-source="arrTabRow"
                  :row-key="(record) => record.id"
                  :pagination="pagination"
                  @change="handleTableChange"
                >
                  <template slot="action" slot-scope="text, record">
                    <Modal :record="record" @getList="getTransactions"></Modal>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </a-spin>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import HinaBaseSlider from "components/HinaBaseSlider/HinaBaseSlider";
import HinaUserInfo from "components/HinaUserInfo/HinaUserInfo";
import HinaBreadCrumb from "components/HinaBreadCrumb/HinaBreadCrumb";
import Modal from "components/Modal/Modal";
import {
  getAllocatedBalance,
  getTotalRecharge,
  getTransactions,
  getUnallocatedBalance,
  pay,
  recharge,
  tonglianToThirdPay,
} from "@/api/balance";
import locale from "ant-design-vue/lib/date-picker/locale/zh_CN";
import vueQr from "vue-qr";
import { nanoid } from "nanoid";
import { createSocket, closeSocket } from "@/config/websocket";

export default {
  name: "Balance",
  components: {
    HinaBaseSlider,
    HinaUserInfo,
    HinaBreadCrumb,
    vueQr,
    Modal,
  },
  data() {
    return {
      locale,
      objUserInfo: {},
      curMenuKey: ["balance"],
      curOpenKey: ["sub2"],
      arrTabCol: [],
      arrTabRow: [],
      arrBreadLink: [],
      strTransType: "交易类型",
      recharge: {
        rechargeAmount: 1000,
        curPayment: 0,
      },
      arrPayment: [],
      totalRecharge: 0,
      allocatedBalance: 0,
      unallocatedBalance: 0,
      enterpriseTransactionTypeDict: [
        { code: 1, value: "充值" },
        { code: 2, value: "在线充值" },
        { code: 3, value: "后台充值" },
        { code: 4, value: "退款" },
        { code: 5, value: "提现" },
        { code: 6, value: "支付" },
        { code: 7, value: "邀请购买年会员奖励" },
        { code: 8, value: "订单分成奖励" }],
      invoiceTypes: [],
      invoiceStates: [""],

      searchForm: {
        pageSize: 10,
        pageNumber: 1,
        type: null,
        startDate: null,
        endDate: null,
      },
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1,
      },
      pay: {
        paymentMethod: "ALLINPAY_WECHAT",
        paymentClient: "NATIVE",
        orderType: "ENTERPRISE_RECHARGE",
        sn: null,
        clientType: "PC_ENTERPRISE",
      },
      spinning: false,
      qrCodeVisible: false,
      qrCode: {
        logoSrc: "",
        text: "",
      },
      socketParams: {
        userId: "",
        serviceType1: "PAY",
        serviceType2: "ENTERPRISE_RECHARGE",
      },
    };
  },
  methods: {
    handleQrCodePaySuccess() {
      // 开始连接 socket
      this.socketParams.userId = this.pay.sn;
      createSocket(undefined, this.socketParams);
      // 监听消息返回
      window.addEventListener("onmessageWS", (e) => {
        console.log("e", e, e.detail);
        let data = {};
        try {
          data = JSON.parse(e.detail.data);
        } catch (e) {}

        if (!this.qrCodeVisible) {
          // 利用心跳监测二维码是否被用户手动关闭
          closeSocket();
        }

        if (typeof data !== "object") {
          // 过滤心跳数据
          return;
        }
        if (data.code == 200 && data.result == this.pay.sn) {
          //流程跑完关闭websocket
          closeSocket();
          this.$message.success("支付成功");
          setTimeout(() => {
            this.qrCodeVisible = false;
            location.reload();
          }, 2000);
        }
      });
    },
    handleRecharge() {
      this.recharge.enterpriseId = this.$store.state.userInfo.id;
      this.spinning = true;

      recharge(this.recharge).then((res) => {
        if (res.data.code == 200) {
          let payInfo = this.arrPayment[this.recharge.curPayment];
          this.pay.sn = res.data.result;
          this.pay.paymentMethod = payInfo.paymentMethod;
          this.pay.paymentClient = payInfo.paymentClient;

          // this.handleQrCodePaySuccess();
          // return;
          pay(this.pay).then((res2) => {
            if (res.data.code == 200) {
              if (payInfo.paymentMethod == "TONGLIAN") {
                var result = res2.result;
                const apiUrl = result.apiUrl;
                delete result.apiUrl;
                tonglianToThirdPay(apiUrl, result);
              } else {
                // 构建二维码
                this.qrCode.text = res2.result.payinfo;
                this.qrCodeVisible = true;

                this.handleQrCodePaySuccess();
              }
            }
          });
        }
      });
      this.spinning = false;
    },
    handleTableChange(pagination, filters, sorter, currentDataSource) {
      this.pagination.current = this.searchForm.pageNumber = pagination.current;
      this.getTransactions();
    },
    getTotalRecharge() {
      getTotalRecharge(this.$store.state.userInfo.id).then((res) => {
        if (res.code == 200) {
          this.totalRecharge = res.result;
        }
      });
    },
    getAllocatedBalance() {
      getAllocatedBalance(this.$store.state.userInfo.id).then((res) => {
        if (res.code == 200) {
          this.allocatedBalance = res.result;
        }
      });
    },
    getUnallocatedBalance() {
      getUnallocatedBalance(this.$store.state.userInfo.id).then((res) => {
        if (res.code == 200) {
          this.unallocatedBalance = res.result;
        }
      });
    },
    getTransactions() {
      let params = {
        ...this.searchForm,
        uid: this.$store.state.userInfo.id,
        sort: "create_time",
        order: "desc",
      };
      getTransactions(params).then((res) => {
        if (res.code == 200) {
          this.arrTabRow = res.result.records;
          this.pagination.total = res.result.total;

          if (this.arrTabRow.length != 0 || this.pagination.current == 1) {
            return;
          }
          this.pagination.current = this.searchForm.pageNumber =
            res.result.pages;
          this.getTransactions();
        }
      });
    },
    handlerChangePayment: function (e) {
      let eIndex = e.currentTarget.dataset.index;
      this.recharge.curPayment = parseInt(eIndex);
      console.log("e:", e, eIndex);
    },
    handleMenuClick: function (e) {
      console.log("click", e);
      this.searchForm.type = e.key;
    },
    onDateTimeChange: function (value, dateString) {
      console.log("Selected Time: ", value);
      console.log("Formatted Selected Time: ", dateString);
      this.searchForm.startDate = dateString[0];
      this.searchForm.endDate = dateString[1];
    },
    onDateTimeOk: function (value) {
      console.log("onDateTimeOk: ", value);
    },
  },
  mounted: function () {
    this.getTotalRecharge();
    this.getAllocatedBalance();
    this.getUnallocatedBalance();
    this.getTransactions();

    this.objUserInfo =
      JSON.parse(localStorage.getItem("userInfo")) ||
      this.$store.state.userInfo;
    this.arrBreadLink.push({ name: "资金信息  ", link: "/balance" });

    this.arrPayment.push({
      icon: require("assets/payment/icon-wechat.png"),
      paymentMethod: "ALLINPAY_WECHAT",
      paymentClient: "NATIVE",
      paymentName: "微信支付",
    });
    this.arrPayment.push({
      icon: require("assets/payment/icon-alipay.png"),
      paymentMethod: "ALLINPAY_ALI",
      paymentClient: "NATIVE",
      paymentName: "支付宝支付",
    });
    this.arrPayment.push({
      icon: require("assets/payment/icon-other.png"),
      paymentMethod: "TONGLIAN",
      paymentClient: "H5",
      paymentName: "通联支付",
    });

    this.invoiceTypes.push({ code: null, value: "未选择" });
    this.invoiceTypes.push({ code: 1, value: "普通发票" });
    this.invoiceTypes.push({ code: 2, value: "专用发票" });
    this.invoiceStates.push({ code: 1, value: "未发票" });
    this.invoiceStates.push({ code: 2, value: "申请中" });
    this.invoiceStates.push({ code: 3, value: "已发票" });
    this.arrTabCol = [
      {
        title: "交易日期",
        dataIndex: "createTime",
        key: "createTime",
        width: "180px",
      },
      {
        title: "交易类型",
        dataIndex: "type",
        key: "type",
        width: "120px",
        customRender: (text, record, index, column) => {
          return this.enterpriseTransactionTypeDict.find((e) => e.code == text)
            .value;
        },
      },
      // {
      //   title: "企业名称",
      //   dataIndex: "userName",
      //   key: "userName",
      //   width: "120px",
      // },
      {
        title: "交易金额",
        dataIndex: "money",
        key: "money",
        width: "120px",
      },
      // {
      //   title: "交易前余额",
      //   dataIndex: "oldMoney",
      //   key: "oldMoney",
      //   width: "120px",
      // },
      // {
      //   title: "交易后余额",
      //   dataIndex: "newMoney",
      //   key: "newMoney",
      //   width: "120px",
      // },
      {
        title: "发票申请日期",
        dataIndex: "invoiceApplicationDate",
        key: "invoiceApplicationDate",
        width: "120px",
      },
      {
        title: "发票状态",
        dataIndex: "invoiceState",
        key: "invoiceState",
        width: "120px",
        customRender: (text, record, index, column) => {
          return this.invoiceStates.find((e) => e.code == text).value;
        },
      },
      {
        title: "发票类型",
        dataIndex: "invoiceType",
        key: "invoiceType",
        width: "120px",
        customRender: (text, record, index, column) => {
          return this.invoiceTypes.find((e) => e.code == text).value;
        },
      },
      {
        title: "开票申请",
        width: "120px",
        scopedSlots: { customRender: "action" },
      },
    ];
    this.arrTabCol.forEach((item) => {
      console.log(item);
    });
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding-bottom: 15px;
  .wrap {
    margin: 20px 0 0;
    padding: 0 24px;
    background: #fff;
    min-height: 240px;
    .hd {
      height: 72px;
      line-height: 72px;
      color: #333;
      font-weight: 600;
      font-size: 18px;
      position: relative;
      margin-bottom: 30px;
      &::after {
        position: absolute;
        content: "";
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        left: 0;
        right: 0;
        bottom: 0;
      }
      .filter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .query {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .query-item {
            padding: 0 0 0 5px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .bd {
      padding: 0 0 30px;
      .frm-line {
        min-height: 72px;
        padding: 12px 0;
        box-sizing: border-box;
        .lab {
          font-size: 16px;
          line-height: 48px;
          text-align: right;
          position: relative;
          &::after {
            position: relative;
            content: "：";
          }
        }
        .required {
          &::before {
            position: relative;
            content: "*";
            color: red;
            padding: 0 5px 0 0;
          }
        }
        .txt {
          line-height: 48px;
          font-size: 16px;
          .ant-input {
            height: 48px;
          }
        }
        .txt-money {
          height: 48px;
          line-height: 48px;
        }
        .btn {
          .ant-btn {
            font-size: 16px;
            height: 48px !important;
          }
        }
      }
    }
    .trans-table {
      padding: 0 0 5px;
    }
    .counter-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      margin: 0 0 40px;
      .lab {
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        color: #999;
      }
      .txt {
        font-size: 36px;
        height: 60px;
        line-height: 60px;
        color: #444;
      }
    }
    .pay {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .pay-item {
        width: 160px;
        height: 48px;
        box-sizing: border-box;
        cursor: pointer;
        border: 2px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 10px 0 0;
        .pic {
          width: 132px;
          height: 40px;
        }
        .ico {
          width: 32px;
          height: 32px;
        }
        .inf {
          padding: 0 0 0 10px;
          font-size: 16px;
          font-weight: 600;
          line-height: 48px;
        }
      }
      .pay-item_hov {
        border: 2px solid #e4393c;
        position: relative;
        &::after {
          position: absolute;
          content: "";
          right: -1px;
          bottom: -1px;
          width: 12px;
          height: 12px;
          background: url("~assets/payment/icon-selected.png");
        }
      }
    }
    .amount-list {
      .amount-item {
        .counter-box {
          position: relative;
          &::after {
            position: absolute;
            content: "";
            right: 0;
            top: 15px;
            bottom: 15px;
            width: 1px;
            background: rgba(0, 0, 0, 0.1);
          }
        }
      }
      .amount-item:last-of-type {
        .counter-box {
          &::after {
            display: none;
          }
        }
      }
    }
  }
  .wrap:first-of-type {
    margin: 0;
  }
}
</style>
